import React from "react";
import hoistNonReactStatic from "hoist-non-react-statics";
import Trackable from "./Trackable";
export const withTrack = options => {
  if (typeof options === "string") {
    options = {
      loadId: options
    };
  }

  return WrappedComponent => {
    class WithTrack extends React.Component {
      render() {
        return /*#__PURE__*/React.createElement(Trackable, {
          loadId: options.loadId,
          interfaceId: options.interfaceId,
          context: options.context
        }, /*#__PURE__*/React.createElement(WrappedComponent, this.props));
      }

    }

    WithTrack.displayName = "WithTrack";
    hoistNonReactStatic(WithTrack, WrappedComponent);
    return WithTrack;
  };
};